export const PayVaultAPIErrorCodesConstant = {
    AUTHENTICATION_FAILURE: 'authentication_failure',
    INVALID_REQUEST_PARAMETER: 'invalid_request_parameters',
    SYSTEM_ERROR: 'system_error',
    UNAUTHORIZED_ACCESS: 'unauthorized_access',
    UNDER_MAINTENANCE: 'under_maintenance',
};
